import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { language } from "language/default";
import React from "react";
import "./insSettingsTimePeriod.scss";
export const InsDashboardButtons = ({ isApplyDisabled, onApply, onCancel, onReset }) => React.createElement("div", { className: "button-row" },
    React.createElement(AuxButton, { label: language.en.common.reset, type: AuxButtonTypeEnum.SECONDARY, onClick: onReset }),
    React.createElement("div", { className: "button-row__right" },
        React.createElement(AuxButton, { label: language.en.common.cancel, onClick: onCancel, type: AuxButtonTypeEnum.SECONDARY }),
        React.createElement(AuxButton, { type: AuxButtonTypeEnum.PRIMARY, label: language.en.filter.applyFilters, isDisabled: isApplyDisabled, onClick: onApply })));
